import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { LayoutContainer } from '../../styledComponents/LayoutContainer/LayoutContainer'
import HeaderComponent from '../../components/HeaderComponent/HeaderComponent'
class PageLayout extends Component {
  constructor (props) {
    super()
    this.state = {}
  }

  static propTypes = {
    children: PropTypes.element.isRequired,
    params: PropTypes.any
  }

  render () {
    return (
      <LayoutContainer>
        <HeaderComponent params={this.props.params}/>
        {this.props.children}
      </LayoutContainer>
    )
  }
}

export default connect()(PageLayout)



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/PageLayout.js